import angular from 'angular';
import { TwoFactorVerificationSimpleCodeInputComponent } from './two-factor-verification-simple-code-input';

export const TwoFactorVerificationSimpleCodeInputModule = angular.module('buildium.manager.components.two-factor-verification-simple-code-input', [

])
    .component('bdTwoFactorVerificationSimpleCodeInput', TwoFactorVerificationSimpleCodeInputComponent);
